(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/co-op-context.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/co-op-context.js');
"use strict";


const {
  createContext,
  useMemo,
  useState
} = React;
const CoOpContext = createContext();
const CoOpProvider = _ref => {
  let {
    children
  } = _ref;
  const [active, setActive] = useState({});
  const value = useMemo(() => ({
    active,
    setActive
  }), [active, setActive]);
  return React.createElement(CoOpContext.Provider, {
    value: value
  }, children);
};
setGlobal('svs.components.tipsen.CoOpContext', CoOpContext);
setGlobal('svs.components.tipsen.CoOpProvider', CoOpProvider);

 })(window);